/**
 * Resolve the largest visible general portrait element for battlefield VFX anchoring.
 */
export function getGeneralZoneRect(dataZone) {
  if (typeof document === 'undefined' || !dataZone) {
    return null;
  }
  const candidates = document.querySelectorAll(`[data-zone="${dataZone}"]`);
  let bestEl = null;
  let bestArea = -1;
  candidates.forEach((el) => {
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return;
    }
    const r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) {
      return;
    }
    const area = r.width * r.height;
    if (area > bestArea) {
      bestArea = area;
      bestEl = el;
    }
  });
  if (!bestEl) {
    return null;
  }
  return bestEl.getBoundingClientRect();
}
